import { Module } from "vuex";

export interface QuizState {
  activeQuizzes: { [key: string]: any };
}

const quizModule: Module<QuizState, any> = {
  namespaced: true,
  state: {
    activeQuizzes: {},
  },
  mutations: {
    SET_ACTIVE_QUIZ(state, { quizId, layout }) {
      state.activeQuizzes = {
        ...state.activeQuizzes,
        [quizId.toLowerCase()]: layout,
      };
    },
    REMOVE_ACTIVE_QUIZ(state, quizId) {
      const { [quizId.toLowerCase()]: _, ...remainingQuizzes } = state.activeQuizzes;
      state.activeQuizzes = remainingQuizzes;
    },
  },
  actions: {
    saveQuiz({ commit }, { quizId, layout }) {
      commit("SET_ACTIVE_QUIZ", { quizId, layout });
    },
    removeQuiz({ commit }, quizId) {
      commit("REMOVE_ACTIVE_QUIZ", quizId.toLowerCase());
    },
  },
  getters: {
    getQuiz: (state) => (quizId: string) => {
      return state.activeQuizzes[quizId.toLowerCase()];
    },
    getActiveQuizNames: (state) => {
      return Object.keys(state.activeQuizzes);
    },
  },
};

export default quizModule;
